import { render, staticRenderFns } from "./OTextarea.vue?vue&type=template&id=866148c0&scoped=true&"
import script from "./OTextarea.vue?vue&type=script&lang=js&"
export * from "./OTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866148c0",
  null
  
)

export default component.exports